var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 7.0002C12.6 10.4796 9.77939 13.3002 6.3 13.3002C2.82061 13.3002 0 10.4796 0 7.0002C0 3.5208 2.82061 0.700195 6.3 0.700195C9.77939 0.700195 12.6 3.5208 12.6 7.0002ZM7.0875 10.1502C7.0875 10.5851 6.73492 10.9377 6.3 10.9377C5.86508 10.9377 5.5125 10.5851 5.5125 10.1502C5.5125 9.71527 5.86508 9.3627 6.3 9.3627C6.73492 9.3627 7.0875 9.71527 7.0875 10.1502ZM6.3 3.0627C5.86508 3.0627 5.5125 3.41527 5.5125 3.8502V7.0002C5.5125 7.43512 5.86508 7.7877 6.3 7.7877C6.73492 7.7877 7.0875 7.43512 7.0875 7.0002V3.8502C7.0875 3.41527 6.73492 3.0627 6.3 3.0627Z",
    fill: "#DC2626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3597354144aef3de91792879ff8a1103.svg";
export { ForwardRef as ReactComponent };